
const map = {
    name: "3_2",
    mapType: "surface",
    mapBoundaries: {
        min: {x: 0, y: 4},
        max: {x: 15, y: 14}
    },
    items: [

    ],
    overworld: [
        // blocking side wall?
        {name: "green_bush", coordinates: {x: 15, y: 8}},
        {name: "green_bush", coordinates: {x: 15, y: 9}},
        {name: "green_bush", coordinates: {x: 15, y: 10}},
        // blocking top wall
        // {name: "green_bush", coordinates: {x: 8, y: 4}},
        // {name: "green_bush", coordinates: {x: 9, y: 4}},
        // {name: "green_bush", coordinates: {x: 8, y: 5}},
        // {name: "green_bush", coordinates: {x: 9, y: 5}},

        // top left bush wall
        {name: "green_bush", coordinates: {x: 0, y: 4}},
        {name: "green_bush", coordinates: {x: 1, y: 4}},
        {name: "green_bush", coordinates: {x: 2, y: 4}},
        {name: "green_bush", coordinates: {x: 3, y: 4}},
        {name: "green_bush", coordinates: {x: 4, y: 4}},
        {name: "green_bush", coordinates: {x: 5, y: 4}},
        {name: "green_bush", coordinates: {x: 6, y: 4}},
        {name: "green_bush", coordinates: {x: 0, y: 5}},
        {name: "green_bush", coordinates: {x: 1, y: 5}},
        {name: "green_bush", coordinates: {x: 2, y: 5}},
        {name: "green_bush", coordinates: {x: 3, y: 5}},
        {name: "green_bush", coordinates: {x: 4, y: 5}},
        {name: "green_bush", coordinates: {x: 5, y: 5}},
        {name: "green_bush", coordinates: {x: 6, y: 5}},


        // top right bush wall
        {name: "green_bush", coordinates: {x: 9, y: 4}},
        {name: "green_bush", coordinates: {x: 10, y: 4}},
        {name: "green_bush", coordinates: {x: 11, y: 4}},
        {name: "green_bush", coordinates: {x: 12, y: 4}},
        {name: "green_bush", coordinates: {x: 13, y: 4}},
        {name: "green_bush", coordinates: {x: 14, y: 4}},
        {name: "green_bush", coordinates: {x: 15, y: 4}},
        {name: "green_bush", coordinates: {x: 9, y: 5}},
        {name: "green_bush", coordinates: {x: 10, y: 5}},
        {name: "green_bush", coordinates: {x: 11, y: 5}},
        {name: "green_bush", coordinates: {x: 12, y: 5}},
        {name: "green_bush", coordinates: {x: 13, y: 5}},
        {name: "green_bush", coordinates: {x: 14, y: 5}},
        {name: "green_bush", coordinates: {x: 15, y: 5}},

        // right side bush wall
        {name: "green_bush", coordinates: {x: 15, y: 6}},
        {name: "green_bush", coordinates: {x: 15, y: 7}},

        {name: "green_bush", coordinates: {x: 15, y: 11}},
        {name: "green_bush", coordinates: {x: 15, y: 12}},
        {name: "green_bush", coordinates: {x: 15, y: 13}},
        {name: "green_bush", coordinates: {x: 15, y: 14}},

        // left side bush wall
        {name: "green_bush", coordinates: {x: 0, y: 13}},
        {name: "green_bush", coordinates: {x: 0, y: 14}},
        {name: "green_bush", coordinates: {x: 1, y: 13}},
        {name: "green_bush", coordinates: {x: 1, y: 14}},
        {name: "green_bush", coordinates: {x: 2, y: 13}},
        {name: "green_bush", coordinates: {x: 2, y: 14}},

        // bottom bushes
        {name: "green_bush", coordinates: {x: 4, y: 13}},
        {name: "green_bush", coordinates: {x: 4, y: 14}},
        {name: "green_bush", coordinates: {x: 6, y: 13}},
        {name: "green_bush", coordinates: {x: 6, y: 14}},
        {name: "green_bush", coordinates: {x: 9, y: 13}},
        {name: "green_bush", coordinates: {x: 9, y: 14}},
        {name: "green_bush", coordinates: {x: 11, y: 13}},
        {name: "green_bush", coordinates: {x: 11, y: 14}},
        {name: "green_bush", coordinates: {x: 13, y: 13}},
        {name: "green_bush", coordinates: {x: 13, y: 14}},

        // bush field
        {name: "green_bush", coordinates: {x: 0, y: 11}},
        {name: "green_bush", coordinates: {x: 2, y: 11}},
        {name: "green_bush", coordinates: {x: 6, y: 11}},
        {name: "green_bush", coordinates: {x: 9, y: 11}},
        {name: "green_bush", coordinates: {x: 11, y: 11}},

        {name: "green_bush", coordinates: {x: 0, y: 9}},
        {name: "green_bush", coordinates: {x: 2, y: 9}},
        {name: "green_bush", coordinates: {x: 4, y: 9}},
        {name: "green_bush", coordinates: {x: 6, y: 9}},
        {name: "green_bush", coordinates: {x: 9, y: 9}},
        {name: "green_bush", coordinates: {x: 11, y: 9}},
        {name: "green_bush", coordinates: {x: 13, y: 9}},

        {name: "green_bush", coordinates: {x: 0, y: 7}},
        {name: "green_bush", coordinates: {x: 2, y: 7}},
        {name: "green_bush", coordinates: {x: 6, y: 7}},
        {name: "green_bush", coordinates: {x: 9, y: 7}},
        {name: "green_bush", coordinates: {x: 11, y: 7}},

    ]
}

export default map
